export const imageMatcherResultPageLoader = async ({params}: any) => {
    try {
        return params.uuid as string;
    } catch (error) {
        throw error;
    }
}
